import React from 'react';
import { observable } from 'mobx';
import { observer } from 'mobx-react';
import { withRouter } from 'react-router-dom';
import format from 'date-fns/format';

import { Button } from '@smartplatform/ui';
import { canCreateVotingForSession, createVotingForSession, getCommitteeQuestions } from '../voting';
import store from '../../store';
import './style.scss';

@withRouter @observer
export default class View extends React.Component {

	@observable record = null;
	@observable error = null;
	@observable isLoading = true;
	@observable questions = [];
	@observable openVote = false;
	@observable existingSessionId = null;
	
	constructor(props) {
		super(props);
		this.init();
	}
	
	init = async () => {
		this.id = this.props.match.params.id;
		if (this.id) {
			try {
				this.record = await store.model.Document.findById(this.id);
				if (this.record) {
					const { canCreate, sessionId } = await canCreateVotingForSession(this.record);
					this.openVote = canCreate;
					this.existingSessionId = sessionId;
					this.questions = await getCommitteeQuestions(this.record.id);
				}
			}
			catch (e) {
				this.error = e.message;
			}
		}
		this.isLoading = false;
	};
	
	gotoExistingSession = () => {
		store.route.push({ path: `/admin/voting/${this.existingSessionId}` });
	};
	
	startRegistration = async () => {
		console.log('startRegistration');
		await createVotingForSession(this.record);
	};
	
	render() {
		if (this.isLoading) return '...';
		
		return <div className="committee-session">
			<div className="form-field">
				<label>Наименование</label>
				<div>{this.record.name}</div>
			</div>
			<div className="form-field">
				<label>Дата</label>
				<div>{this.record.date ? format(new Date(this.record.date), 'dd.MM.yyyy') : '-'}</div>
			</div>
			{this.existingSessionId && <div className="form-field">
				<Button className="btn-primary" onClick={this.gotoExistingSession}>Просмотреть голосование</Button>
			</div>}
			
			{this.openVote && <div className="form-field">
				<Button className="btn-primary" onClick={this.startRegistration}>Создать голосование</Button>
			</div>}
			
			<hr />
			
			<ol className="questions">
				{this.questions.map(question => <li key={question.id} className="question">
					<strong>{question.name}</strong>
					<ul className="files">
						{question.files.map(file => <li key={file.id}>
							<a target="_blank" href={file.url}>{file.name}</a>
						</li>)}
					</ul>
				</li>)}
			</ol>
		</div>;
	}
	
}

